<template>
    <div class="gathering">
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('sms.codeName')">
                <Input v-model="formItem.pay_qrcode_title"></Input>
            </FormItem>
            <FormItem :label="$t('Thumbnail')">
                <div class="file_box">
                    <img class="id_img" :src="$ht_ip + formItem.pay_qrcode" v-show="formItem.pay_qrcode" alt />
                    <div class="img" v-show="!formItem.pay_qrcode">
                        <p class="gray_color">{{$t('selectPhoto')}}</p>
                    </div>
                    <input type="file" accept="image/*" @change="get_file($event)" />
                </div>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
                <Button style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>
    </div>
</template>



<script>

export default {
    
    data() {
        return {
            formItem: {}
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        doPost() {
            this.$post(this.$path.system, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                } else {
                    this.$Message.error(this.$i18n.t('操作失败'));
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.system, {
                
            }).then(res => {
                if (res.data) {
                    this.formItem = res.data;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        get_file(e) {
            this.img_load = true;
            let formData = new FormData();
            formData.append("img", e.currentTarget.files[0]);
            this.$file(this.$path.upload, formData)
                .then(res => {
                    this.img_load = false;
                    this.formItem.pay_qrcode = res.data.path;
                })
                .catch(err => {
                    this.img_load = false;
                });
        }
    }
    
};
</script>

<style lang="scss" scoped>
.file_box {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: 1px #eeeeee dashed;
    border-radius: 4px;
    img {
        width: 100%;
        height: 100%;
    }
    .img {
        width: 100%;
        height: 100%;
        p {
            text-align: center;
            color: #bab9b9;
            margin-top: 50px;
        }
    }
    input {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 130px;
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/system/gathering.vue